<template><section><h3>Custom Form Example</h3>
<p><strong>Script</strong></p>
<pre v-pre><code v-pre class="language-javascript"><span class="hljs-keyword">import</span> ComponentForm <span class="hljs-keyword">from</span> <span class="hljs-string">'@/components/Demo/CustomComponent/ComponentForm.vue'</span>
<span class="hljs-keyword">this</span>.$popup(<span class="hljs-string">'append'</span>, {
  <span class="hljs-attr">component</span>: ComponentForm,
  <span class="hljs-attr">apply</span>: {
    callback(data) {
      alert(<span class="hljs-string">`Quantity: <span class="hljs-subst">${data}</span>`</span>)
    }
  },
})
</code></pre>
<p><strong>CustomComponent/ComponentForm.vue</strong></p>
<pre v-pre><code v-pre class="language-html"><span class="hljs-tag">&lt;<span class="hljs-name">template</span>&gt;</span>
  <span class="hljs-tag">&lt;<span class="hljs-name">div</span> <span class="hljs-attr">foobar</span>&gt;</span>
    <span class="hljs-tag">&lt;<span class="hljs-name">h4</span>&gt;</span>Custom Form<span class="hljs-tag">&lt;/<span class="hljs-name">h4</span>&gt;</span>

    <span class="hljs-tag">&lt;<span class="hljs-name">strong</span>&gt;</span>Select quantity<span class="hljs-tag">&lt;/<span class="hljs-name">strong</span>&gt;</span>

    <span class="hljs-tag">&lt;<span class="hljs-name">select</span> <span class="hljs-attr">class</span>=<span class="hljs-string">"form-control"</span> <span class="hljs-attr">v-model</span>=<span class="hljs-string">"quantity"</span> <span class="hljs-attr">@change</span>=<span class="hljs-string">"syncData"</span>&gt;</span>
      <span class="hljs-tag">&lt;<span class="hljs-name">option</span> <span class="hljs-attr">:value</span>=<span class="hljs-string">"i"</span> <span class="hljs-attr">v-for</span>=<span class="hljs-string">"i in 10"</span>&gt;</span>{{i}}<span class="hljs-tag">&lt;/<span class="hljs-name">option</span>&gt;</span>
    <span class="hljs-tag">&lt;/<span class="hljs-name">select</span>&gt;</span>
  <span class="hljs-tag">&lt;/<span class="hljs-name">div</span>&gt;</span>
<span class="hljs-tag">&lt;/<span class="hljs-name">template</span>&gt;</span>

<span class="hljs-tag">&lt;<span class="hljs-name">script</span> <span class="hljs-attr">lang</span>=<span class="hljs-string">"babel"</span> <span class="hljs-attr">type</span>=<span class="hljs-string">"text/babel"</span>&gt;</span><span class="javascript">
<span class="hljs-keyword">export</span> <span class="hljs-keyword">default</span> {
  data() {
    <span class="hljs-keyword">return</span> {
      <span class="hljs-attr">quantity</span>: <span class="hljs-number">1</span>,
    }
  },
  mounted() {
    <span class="hljs-keyword">this</span>.syncData()
  },
  <span class="hljs-attr">methods</span>: {
    syncData() {
      <span class="hljs-keyword">this</span>.$emit(<span class="hljs-string">'updateData'</span>, <span class="hljs-keyword">this</span>.quantity)
    }
  },
}
</span><span class="hljs-tag">&lt;/<span class="hljs-name">script</span>&gt;</span>
</code></pre>
</section></template>

<script lang="babel" type="text/babel">
export default {
  data() {
    return {
      quantity: 1,
    }
  },
  mounted() {
    this.syncData()
  },
  methods: {
    syncData() {
      this.$emit('updateData', this.quantity)
    }
  },
}
</script>


// WEBPACK FOOTER //
// src/components/Demo/CustomComponent/ExampleCustomForm.vue